import { AnalysisCharacter, AnalysisScene, AnalysisProp } from '../../../types';

interface AddStateFormState {
  name: string;
  episodeCount: number;
  loading: boolean;
}

// 「新增状态」确认条件:名称非空 + 剧集必填(≥1)+ 非加载中。
// 供按钮 disabled / Enter 快捷键 / 提交守卫三处共用,消除 Enter 绕过禁用。
export const canConfirmAddState = (form: AddStateFormState): boolean =>
  !form.loading && form.name.trim().length > 0 && form.episodeCount > 0;

export const newCharacterState = (
  name: string,
  state: string,
  desc: string,
  episodes: number[],
): AnalysisCharacter => ({
  name,
  state,
  appearance: desc,
  personality: '',
  imagePrompt: '',
  episodes,
});

export const newSceneState = (
  name: string,
  state: string,
  desc: string,
  episodes: number[],
): AnalysisScene => ({
  name,
  state,
  description: desc,
  atmosphere: '',
  imagePrompt: '',
  episodes,
});

export const newPropState = (
  name: string,
  state: string,
  desc: string,
  episodes: number[],
): AnalysisProp => ({
  name,
  state,
  description: desc,
  imagePrompt: '',
  episodes,
});
